import moment from 'moment'

export default function toHumanDate(date) {
  if (!date) return ''
  return moment(date).format('DD/MM/YYYY')
}
